import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "17", y2: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "6 11 12 17 18 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 21H5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowDownToLine";
const ArrowDownToLine = memo(themed(Icon));
export {
  ArrowDownToLine
};
//# sourceMappingURL=arrow-down-to-line.js.map
